import React, { useState } from 'react';
import ReactGA from 'react-ga4';
import styles from "./SellerInfoCard/sellerInfoCard.scss"
import { HoneypotInput, useAntiBotMeasures } from '../hooks/useAntiBotMeasures';

interface GAEvent {
  category: string;
  action: string;
  label: string;
}

interface PhoneNumberRevealButtonProps {
  phoneNumber: string;
  index: number;
  adId?: string;
  gaEvent: GAEvent;
}

// Masks phone numbers that appear inline inside user-generated text
// (descriptions, chat messages). This is a pure show/hide toggle on a
// preloaded string; the rate-limited /phone/reveal endpoints are only
// used for the canonical ad/seller phone fields, not for these regex
// matches inside free text.
const PhoneNumberRevealButton: React.FC<PhoneNumberRevealButtonProps> = ({ phoneNumber, gaEvent }) => {
  const [isShown, setIsShown] = useState(false);
  const { honeypotRef, handleClickWithAntiBotMeasure } = useAntiBotMeasures();

  const handleIsShownChange = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isShown) {
      ReactGA.event(gaEvent);
      setIsShown(true);
    }
  };

  const handleClick = (event: React.MouseEvent) =>
    handleClickWithAntiBotMeasure(event, handleIsShownChange);

  return (
    <React.Fragment>
      <HoneypotInput ref={honeypotRef} />
      <span
        onClick={handleClick}
        className={isShown ? styles.showPhoneRevealed : styles.showPhone}
      >
        {isShown ? phoneNumber : 'Prikaži telefon'}
      </span>
    </React.Fragment>
  );
};

export default PhoneNumberRevealButton;

// Factory function for creating PhoneNumberRevealButton without JSX
export const createPhoneNumberRevealButton = (phoneNumber: string, index: number, gaEvent: GAEvent, adId?: string, key?: string) => {
  return React.createElement(PhoneNumberRevealButton, { phoneNumber, index, gaEvent, adId, key });
};



// WEBPACK FOOTER //
// ./src/components/PhoneNumberRevealButton.tsx